<template></template>
<script>
    export default {
        name: "scroll-on-load",
        props: ['id'],
        mounted() {
            let query = window.location.search;
            if(query !== '') {
                document.getElementById(this.id).scrollIntoView();
            }
        },
        methods: {
            changeURL() {
                let query = window.location.search;
                query = query.replace(/[^?=&]+=(&|$)/g, "").replace(/&$/, "");
                history.pushState({}, "Searching query", this.header + query);
            },
        }
    }
</script>
